import { formatDate } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NewTicketComponent } from 'src/app/components/new-lok/new-ticket/new-ticket.component';
import { InfoCardComponent } from 'src/app/components/shared/info-card/info-card.component';
import { CreateEventService } from 'src/app/services/create-event.service';
import { EventosService } from 'src/app/services/eventos.service';
import { SeatMapService } from 'src/app/services/seat-map.service';
import { SessionsService } from 'src/app/services/sessions.service';
import { TicketsService } from 'src/app/services/tickets.service';
import { __values } from 'tslib';

@Component({
  selector: 'app-tickets-create',
  templateUrl: './tickets-create.component.html',
  styleUrls: ['./tickets-create.component.scss']
})
export class TicketsCreateComponent {

  @Input() idEvent!: any;
  idVenue: any = 1;
  @Input() venue!: any;
  @Input() useMapVenue: boolean = false;

  tickets: any[] = [];
  ticketsBase!: any[];

  // Inline table state
  addingTicketRow: boolean = false;
  pendingTicket: any = { name: '', price: null, only_tpv_sales: false, allow_discounts: true, active: true, levels: [], sessions: [], special_seats: false, seats: [] };
  @ViewChild('pendingNameInput') pendingNameInput!: ElementRef;

  displayedColumns: string[] = ['name', 'price'];
  levelColumns: string[] = ['levelName', 'levelEmpty']; // ✅ Columnas para la fila del nivel

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  loaded: boolean = false;
  loadingPage: boolean = true;

  page = 1;
  event!: any;

  finishScroll: boolean = false;
  @ViewChild('containerScroll', { static: false }) containerScroll: ElementRef;
  @Input() configTickets!: any;

  @Output() changeTab: EventEmitter<any> = new EventEmitter<any>();
  @Output() saveTickets: EventEmitter<any> = new EventEmitter<any>();
  changing: boolean = false;

  subscriber!: any;
  resumeConfig!: any;

  // Config
  formConfig!: FormGroup;
  typeDatepicker!: string;
  // Start and End Date
  startStringDate!: any;
  endStringDate!: any;
  startDate!: NgbDate;
  endDate!: NgbDate;

  publishDate!: any;
  publishStringDate!: any;

  hourInit!: any;
  minuteInit!: any;
  hourEnd!: any;
  minuteEnd!: any;

  sameTickets: boolean = true;
  differentTickets: boolean = false;

  ticketsApi!: any;
  @Input() numTickets: number = 0;
  @Input() loadingTickets: boolean = false;

  // Dates
  datesInfo!: any;
  hoursInfo!: any;

  // sessions: any[] = [{start_date: new Date(), sale_start_date: null, sale_end_date: null, max_tickets_per_user: null}, {start_date: new Date(), sale_start_date: null, sale_end_date: null, max_tickets_per_user: null}];
  sessions: any[] = [];
  selectedSession: any = null;
  typeTicketsSession: boolean = false;

  levels: any[] = [];
  expandedTickets: Set<number> = new Set();

  // Session expansion tracking
  expandedSessions: { [key: number]: boolean } = {};
  ticketsBySession: { [key: number]: any[] } = {};

  // Hierarchical dropdown properties
  selectedSessionIndices: number[] = [];
  allSelected: boolean = false;
  yearExpanded: { [year: string]: boolean } = {};
  monthExpanded: { [monthYear: string]: boolean } = {};

  hierarchicalData: {
    years: {
      year: string;
      months: {
        monthYear: string;
        monthName: string;
        sessions: { session: any; index: number }[];
      }[];
    }[];
  } = { years: [] };

  isExternalEvent: boolean = false;
  private loadedMapKey: string | null = null;
  private infoSubscriber!: any;

  constructor(private ticketService: TicketsService, private dialog: MatDialog, private router: Router, public formatter: NgbDateParserFormatter,
    private activatedRoute: ActivatedRoute, private eventService: EventosService, private createService: CreateEventService,
    private formBuilder: FormBuilder, private seatMapService: SeatMapService, private sessionsService: SessionsService) { }

  loadSessions() {
    // Load sessions from CreateEventService or SessionsService
    let saved = this.createService.getInfoEvent();
    const sessionsFromCreate = saved?.values?.sessions;
    const sessionsFromService = this.sessionsService.getSessionsSaved();

    this.sessions = sessionsFromCreate || sessionsFromService || [];
  }

  ngOnInit() {
    // Cargar sesiones al inicializar
    this.loadSessions();

    // Suscribirse al observable de sesiones para actualizaciones en tiempo real
    this.sessionsService.sessions.subscribe({
      next: (sessions) => {
        if (sessions) {
          this.sessions = sessions;
        }
      }
    });

    let saved = this.createService.getInfoEvent();

    // Determinar si el evento es de venta externa
    if (saved && saved.values) {
      this.isExternalEvent = !!saved.values.external;
    }

    this.formConfig = this.formBuilder.group({
      sale_start_date: [],
      sale_end_date: [],
      publish_date: [],
      assume_fees: [true],
      need_validation: [false],
      publish: [false],
      max_tickets_per_user: []
    });

    this.formConfig.valueChanges.subscribe((value) => {
      value.typeTicketsSession = this.typeTicketsSession;
      value.sessions = this.sessions;
      this.editConfig(value);
    });

    this.subscriber = this.ticketService.tickets.subscribe({
      next: (res) => {
        this.ticketsApi = this.ticketService.getTicketsNum();
        if (res && !this.changing) {
          this.loadingPage = true;
          this.tickets = res || [];
          // Las entradas del evento pueden llegar después que las base del
          // espacio (son dos peticiones distintas), así que hay que volver a
          // mezclarlas aquí o las base sin configurar se perderían.
          this.mergeBaseTickets();
          this.getData();
        } else if (!this.changing) {
          this.tickets = null;
          this.mergeBaseTickets();
          this.getData();
        }
      }
    });

    // Suscribirse a la info del evento en lugar de leerla una sola vez: si el usuario
    // selecciona el espacio/mapa mientras esta sección ya está montada, debe reaccionar
    // sin necesitar plegar/desplegar la sección (que la remonta y por eso "arreglaba" el bug).
    this.infoSubscriber = this.createService.info.subscribe({
      next: (infoEvent) => {
        if (!infoEvent) return;
        this.applyVenueInfo(infoEvent);
      }
    });

    let config = this.ticketService.getTicketsConfig();
    if (config) {
      this.configTickets = config;
      if (this.configTickets?.sale_start_date) {
        if (typeof (this.configTickets.sale_start_date) == 'string') {
          this.configTickets.sale_start_date = new Date(this.configTickets.sale_start_date);
        }
        if (typeof (this.configTickets.sale_end_date) == 'string') {
          this.configTickets.sale_end_date = new Date(this.configTickets.sale_end_date);
        }
        this.startStringDate = formatDate(this.configTickets.sale_start_date, 'dd/MM/yyyy', 'es');
        this.hourInit = this.configTickets.sale_start_date.getHours();
        this.minuteInit = this.configTickets.sale_start_date.getMinutes();
      }
      if (this.configTickets?.sale_end_date) {
        this.endStringDate = formatDate(this.configTickets.sale_end_date, 'dd/MM/yyyy', 'es');
        this.hourEnd = this.configTickets.sale_end_date.getHours();
        this.minuteEnd = this.configTickets.sale_end_date.getMinutes();
      }
      if (this.configTickets.publish_date) {
        this.publishStringDate = formatDate(this.configTickets.publish_date, 'dd/MM/yyyy', 'es');
      }
      this.formConfig.setValue(this.configTickets);

      // Load tickets by session if available
      if (config.ticketsBySession) {
        this.ticketsBySession = config.ticketsBySession;
      }

      // Load typeTicketsSession if available
      if (config.typeTicketsSession !== undefined) {
        this.typeTicketsSession = config.typeTicketsSession;

        // If typeTicketsSession is already enabled, initialize session expansion
        if (this.typeTicketsSession && this.sessions && this.sessions.length > 0) {
          this.sessions.forEach((session, index) => {
            if (!this.ticketsBySession[index]) {
              this.ticketsBySession[index] = [];
            }
            // Expand first session by default
            if (index === 0) {
              this.expandedSessions[index] = true;
            }
          });
          // Build hierarchical data for dropdown
          this.buildHierarchicalData();
        }
      }
    }
  }

  getData() {
    this.dataSource = new MatTableDataSource(this.tickets);

    this.loaded = true;
    this.loadingPage = false;
    this.finishScroll = true;
  }

  private applyVenueInfo(infoEvent: any) {
    this.venue = infoEvent.values?.space;
    this.useMapVenue = infoEvent.values?.use_map || false;
    this.datesInfo = infoEvent.values?.infoDates;
    this.hoursInfo = infoEvent.values?.infoHours;

    if (this.venue && this.useMapVenue) {
      // El observable de info emite muchas veces y no siempre trae el espacio
      // completo: create-event.component reemite el valor del formulario, donde
      // el espacio puede venir de la lista de lugares (sin current_version). Sin
      // versión no se puede pedir el mapa, así que no se marca como cargado y se
      // espera a una emisión que sí la traiga. Antes se marcaba igualmente y la
      // petición salía con .../map-version/undefined: fallaba, las zonas se
      // quedaban vacías para siempre y el diálogo de nueva entrada pedía un
      // precio único en vez de un precio por zona.
      const mapVersion = this.venue.current_version;
      if (!mapVersion) return;

      const mapKey = `${this.venue.id}:${mapVersion}`;
      if (this.loadedMapKey === mapKey) return;
      this.loadedMapKey = mapKey;

      this.seatMapService.getLevelsVersionMap(this.venue.id, mapVersion).subscribe({
        next: (res) => {
          this.levels = res.data;
          this.sortLevelsByOrder(this.levels);
        },
        error: () => {
          // Reintentar en la siguiente emisión en vez de quedarnos sin zonas.
          this.loadedMapKey = null;
        }
      });
      this.ticketService.getTicketsBySpace(this.venue.id).subscribe({
        next: (res) => {
          if (res.data) {
            // Obtener tickets base del espacio
            this.ticketsBase = res.data?.map((ticket: any) => {
              ticket.base = true;
              ticket.enabled = false;
              return ticket;
            });
            this.mergeBaseTickets();
          }
          this.loadingTickets = false;
        }, error: (err) => {
          this.loadingTickets = false;
        }
      });
    } else {
      this.loadedMapKey = null;
      this.ticketsBase = [];
      this.levels = infoEvent.values?.levels || [];
      this.sortLevelsByOrder(this.levels);

      // Si el venue deja de aplicar (p.ej. se elige "Otra dirección"), quitamos
      // las entradas base del espacio que quedaron clonadas sin configurar.
      // `tickets` puede ser null (el subscribe lo pone a null cuando el servicio
      // no tiene entradas), así que no se recorre directamente.
      const hadBaseTickets = (this.tickets || []).some((t: any) => this.isUnconfigured(t));
      if (hadBaseTickets) {
        this.tickets = this.tickets.filter((t: any) => !this.isUnconfigured(t));
        this.getData();
        this.editTickets();
      }
    }
  }

  // Lista las entradas base del espacio que el evento todavía no tiene
  // configuradas, en gris y sin precio, para poder ponérselo más tarde: al crear
  // el evento se pudo dejar alguna sin tocar y hasta ahora solo se veían las
  // entradas base cuando el evento no tenía ninguna entrada (es decir, solo al
  // crearlo). Se emparejan por nombre porque la entrada del evento se crea como
  // copia de la base y no guarda ninguna referencia a ella.
  //
  // No reemite al servicio a propósito: `editTickets()` pone `changing = true` y
  // eso deja sordo al subscribe de `ticketService.tickets`, que es justo por
  // donde llegan las entradas ya configuradas del evento al editarlo. Las
  // entradas sin configurar no hacen falta en el servicio: tanto `validateSteps`
  // como `buildTicketsPayload` (router-create) las descartan.
  private mergeBaseTickets() {
    if (!this.ticketsBase || this.ticketsBase.length === 0) {
      return;
    }

    const current = this.tickets || [];
    const configured = current.filter((ticket: any) => !this.isUnconfigured(ticket));
    const configuredNames = new Set(configured.map((ticket: any) => this.ticketNameKey(ticket)));

    // Reutiliza la fila que ya estuviera pintada para que el array no cambie de
    // identidad en cada llamada (esta se ejecuta en cada emisión de tickets).
    const alreadyPending = new Map<string, any>(
      current
        .filter((ticket: any) => this.isUnconfigured(ticket))
        .map((ticket: any) => [this.ticketNameKey(ticket), ticket])
    );

    const pending = this.ticketsBase
      .filter((base: any) => !configuredNames.has(this.ticketNameKey(base)))
      .map((base: any) => alreadyPending.get(this.ticketNameKey(base)) || { ...base, base: true, enabled: false });

    const merged = [...configured, ...pending];
    if (merged.length === current.length && merged.every((ticket, i) => ticket === current[i])) {
      return;
    }

    this.tickets = merged;
    this.getData();
  }

  private ticketNameKey(ticket: any): string {
    return (ticket?.name || '').trim().toLowerCase();
  }

  editTickets() {
    this.changing = true;
    //aqui no veo cuando se usa ticketsBase no se ve afectado el precio de los tickers seats
    this.ticketService.setTicketsVenue(this.tickets);
  }

  openCreateTicket(ticket: any = true, i?: number) {
    // En un evento con mapa el diálogo pide un precio por zona, y para eso necesita
    // las zonas. Si todavía no están cargadas (una emisión de info sin el espacio
    // completo, un fallo de red al pedirlas) se piden ahora: sin ellas el diálogo
    // caería al formulario de precio único y crearía una entrada sin precios de zona.
    if (this.useMapVenue && this.venue?.current_version && !(this.levels?.length > 0)) {
      this.seatMapService.getLevelsVersionMap(this.venue.id, this.venue.current_version).subscribe({
        next: (res) => {
          this.levels = res.data || [];
          this.sortLevelsByOrder(this.levels);
          if (this.levels.length > 0) {
            this.openTicketDialog(ticket, i);
          } else {
            this.infoDialog('No se han podido cargar las zonas del mapa. Vuelve a intentarlo más tarde.', true);
          }
        },
        error: () => {
          this.loadedMapKey = null;
          this.infoDialog('No se han podido cargar las zonas del mapa. Vuelve a intentarlo más tarde.', true);
        }
      });
      return;
    }

    this.openTicketDialog(ticket, i);
  }

  private infoDialog(msg: string, icon: boolean) {
    this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: { icon, text: msg, btnCancel: false }
    });
  }

  private openTicketDialog(ticket: any = true, i?: number) {
    let newTicket = null;
    if (ticket != true) {
      newTicket = ticket
    }
    let dates = this.datesInfo ? [this.datesInfo] : null;

    // Solo pasar sesiones si typeTicketsSession está activo
    const currentSessions = this.typeTicketsSession ? (this.sessionsService.getSessionsSaved() || this.sessions || []) : [];

    const dialogRef = this.dialog.open(NewTicketComponent, {
      panelClass: ['info-dialog', 'not-padding'],
      data: {
        ticket: newTicket, venue: this.venue, levels: this.levels, sessions: currentSessions,
        eventName: this.createService.getInfoEvent()?.values?.title, useMapVenue: this.useMapVenue,
        // Butacas especiales que ya usa alguna entrada de este evento o del
        // espacio, para poder crear otra sobre ellas (p. ej. una invitación).
        specialSeatsPool: this.ticketService.specialSeatsPool([...(this.tickets || []), ...(this.ticketsBase || [])]),
        specialSeatGroups: this.ticketService.specialSeatGroups([...(this.tickets || []), ...(this.ticketsBase || [])])
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // buildTicketsPayload (router-create) lee las butacas con precio de
        // ticket_seats, no de seats, y de ahí deduce que la entrada es especial.
        if (result.special_seats) {
          result.ticket_seats = result.seats || [];
        }
        // Si typeTicketsSession está activo y hay sesiones seleccionadas
        if (this.typeTicketsSession && result.sessions && result.sessions.length > 0) {
          // Agregar la entrada a cada sesión seleccionada
          result.sessions.forEach((session: any) => {
            const sessionIndex = this.sessions.findIndex(s => s.start_date === session.start_date);
            if (sessionIndex !== -1) {
              if (!this.ticketsBySession[sessionIndex]) {
                this.ticketsBySession[sessionIndex] = [];
              }

              // Crear una copia de la entrada para esta sesión
              const ticketCopy = { ...result, id_session: session.id };

              if (!newTicket) {
                this.ticketsBySession[sessionIndex].push(ticketCopy);
              } else {
                // Buscar el índice del ticket en esta sesión para editarlo
                const ticketIndex = this.ticketsBySession[sessionIndex].findIndex(t => t.id === newTicket.id);
                if (ticketIndex !== -1) {
                  this.ticketsBySession[sessionIndex][ticketIndex] = ticketCopy;
                }
              }

              this.ticketsBySession[sessionIndex].sort((a: any, b: any) => this.getTicketMinOrderBuy(a) - this.getTicketMinOrderBuy(b));
            }
          });

          this.saveTicketsToService();
        } else {
          // Modo normal (sin sesiones)
          if (!this.tickets) {
            this.tickets = [];
          }
          if (!newTicket) {
            this.tickets.push(result);
            this.numTickets++;
          } else {
            this.tickets[i!] = result;
          }
          this.tickets?.sort((a: any, b: any) => this.getTicketMinOrderBuy(a) - this.getTicketMinOrderBuy(b));
          this.changing = false;
          this.ticketService.setTicketsVenue(this.tickets);
          this.ticketService.setTicketsNum(this.numTickets);
          // Actualizar la vista
          this.getData();
        }
      }
    });
  }
  // Devuelve el orderBuy de un nivel (soporta camelCase y snake_case)
  private getLevelOrderBuy(level: any): number {
    const val = level?.orderBuy ?? level?.order_buy;
    return val != null ? +val : Infinity;
  }

  toggleExpand(ticketId: number): void {
    if (this.expandedTickets.has(ticketId)) {
      this.expandedTickets.delete(ticketId);
    } else {
      this.expandedTickets.add(ticketId);
    }
  }

  isExpanded(ticketId: number): boolean {
    return this.expandedTickets.has(ticketId);
  }

  getPriceLabel(ticket: any): string {
    if (!this.useMapVenue) {
      return ticket.price != null ? ticket.price + '€' : '-';
    }
    const levelList = ticket.ticket_levels || ticket.levels || [];
    const prices = levelList.map((l: any) => l.price).filter((p: any) => p != null && p !== '');
    if (prices.length === 0) return '-';
    const min = Math.min(...prices);
    const max = Math.max(...prices);
    return min === max ? `${min}€` : `${min}€ – ${max}€`;
  }

  // Ordena levels por orderBuy ascendente (nulls al final)
  sortLevelsByOrder(levels: any[]): any[] {
    return levels.sort((a: any, b: any) => this.getLevelOrderBuy(a) - this.getLevelOrderBuy(b));
  }

  // Devuelve el menor orderBuy de los niveles asociados a un ticket
  private getTicketMinOrderBuy(ticket: any): number {
    const ticketLevels = ticket.ticket_levels || ticket.levels || [];
    let minOrder = Infinity;
    for (const tl of ticketLevels) {
      const levelId = tl.level_id ?? tl.id;
      const level = this.levels.find((l: any) => +l.id === +levelId);
      const order = this.getLevelOrderBuy(level);
      if (order < minOrder) minOrder = order;
    }
    // Fallback al campo level del ticket (puede ser orderBuy en datos legacy)
    if (minOrder === Infinity && ticket.level != null) {
      minOrder = +ticket.level;
    }
    return minOrder;
  }

  // esta función se usa para obtener los levels pero no parece funcionar a la hora de tener tickets especiales porque no estan en ticket_levels
  getTicketLevel(ticket: any, levelId: number) {
    if (ticket.ticket_seats && ticket.ticket_seats.length > 0) {
      let seatLevel = ticket.ticket_seats?.find((element: any) => element.seat.id_level == levelId);
      if (seatLevel) {
        return seatLevel;
      } else {
        return { price: null, hidden: true };
      }
    }

    let ticketlevels = ticket.ticket_levels || ticket.levels;
    if (ticketlevels && ticketlevels.length > 0) {
      let level = ticketlevels.find((element: any) => element.level_id == levelId || element.id == levelId);
      if (level) return level;
      // Try name-based match (base ticket IDs differ from map version IDs)
      const mapLevel = this.levels.find((l: any) => l.id == levelId);
      if (mapLevel) {
        const namedLevel = ticketlevels.find((tl: any) => tl.level?.name === mapLevel.name);
        if (namedLevel) return namedLevel;
      }
      return { price: null, active: false, restricted: true };
    }
    return { price: null, hidden: true };
  }

  isUnconfigured(ticket: any): boolean {
    return ticket.base === true && ticket.enabled === false;
  }

  onTicketRowClick(ticket: any) {
    if (this.isUnconfigured(ticket)) {
      this.openConfigureBaseTicket(ticket);
    } else {
      this.toggleExpand(ticket.id);
    }
  }

  openConfigureBaseTicket(baseTicket: any) {
    const allowedLevelNames = (() => {
      const levels = (baseTicket.ticket_levels || []).filter((tl: any) => tl?.level?.name);
      if (!levels.length) return null;
      return new Set(levels.map((tl: any) => tl.level.name as string));
    })();

    const dialogRef = this.dialog.open(NewTicketComponent, {
      panelClass: ['info-dialog', 'not-padding'],
      data: {
        ticket: {
          name: baseTicket.name,
          active: true,
          price: baseTicket.price ?? null,
          only_tpv_sales: baseTicket.only_tpv_sales || false,
          allow_discounts: baseTicket.allow_discounts !== false,
          special_seats: baseTicket.special_seats || false,
          ticket_levels: null,
          // Las entradas de butacas especiales (p. ej. "Movilidad reducida") no se
          // cobran por zona sino butaca a butaca, y esas butacas ya vienen definidas
          // en la entrada base del espacio. Si se abre el diálogo sin ellas no hay
          // nada a lo que ponerle precio y la configuración se pierde entera.
          // Copia propia y sin precio: el de la entrada base es siempre 0 y es un hueco
          // por rellenar, no un precio de verdad. Heredarlo pintaba "0,00 €" en las
          // zonas con butacas, que se lee como configurado y se puede guardar gratis.
          // Las zonas por nivel se pasan igual, a null (ticket_levels).
          ticket_seats: (baseTicket.ticket_seats || []).map((ticketSeat: any) => ({
            ...JSON.parse(JSON.stringify(ticketSeat)),
            price: null,
          })),
          sessions: [],
        },
        configureOnly: true,
        allowedLevelNames,
        venue: this.venue,
        seats: [],
        levels: this.levels || [],
        eventName: this.createService.getInfoEvent()?.values?.title,
        useMapVenue: this.useMapVenue
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;

      if (this.useMapVenue) {
        // Con butacas especiales el precio NO viaja en levels: NewTicketComponent lo
        // pone a null a propósito y reparte el precio de cada zona entre las butacas
        // de la entrada. Mirar solo levels daba siempre "sin precio" y descartaba en
        // silencio todo lo que el usuario acababa de escribir.
        const priced: any[] = result.special_seats ? (result.seats || []) : (result.levels || []);
        const hasPrice = priced.some((p: any) => p.price != null && +p.price >= 0);
        if (!hasPrice) return;
      } else if (result.price == null || +result.price < 0) {
        return;
      }

      const idx = this.tickets.findIndex((t: any) => t.id === baseTicket.id);
      if (idx !== -1) {
        this.tickets[idx] = {
          ...this.tickets[idx],
          ...result,
          ticket_levels: null,
          // buildTicketsPayload (router-create) lee las butacas con precio de
          // ticket_seats, no de seats, y de ahí deduce que la entrada es especial.
          ticket_seats: result.special_seats ? (result.seats || []) : (this.tickets[idx].ticket_seats || []),
          enabled: true,
          base: true,
        };
        this.editTickets();
        this.getData();
      }
    });
  }

  deleteTicket(ticket: any, i: any) {
    this.tickets.splice(i, 1);
    this.numTickets--;
    this.ticketService.setTicketsVenue(this.tickets);
    this.ticketService.setTicketsNum(this.numTickets);
  }

  // Estado (activa/inactiva) de la entrada. Las entradas base del espacio que
  // todavía no se han configurado no se pueden activar desde el toggle: primero
  // hay que ponerles precio en el diálogo, así que este lo abre y deja el toggle
  // como estaba hasta que se guarde la configuración.
  toggleTicketActive(ticket: any, event: any) {
    if (this.isUnconfigured(ticket)) {
      if (event) event.source.checked = false;
      this.openConfigureBaseTicket(ticket);
      return;
    }
    ticket.active = event.checked;
    this.editTickets();
  }

  toggleOnlyTpvSales(ticket: any, event: any) {
    ticket.only_tpv_sales = event.checked;
    this.editTickets();
  }

  toggleAllowDiscounts(ticket: any, event: any) {
    ticket.allow_discounts = event.checked;
    this.editTickets();
  }

  // ─── Inline table methods ─────────────────────────────────────
  startAddTicketRow() {
    this.pendingTicket = { name: '', price: null, only_tpv_sales: false, allow_discounts: true, active: true, levels: [], sessions: [], special_seats: false, seats: [] };
    this.addingTicketRow = true;
    setTimeout(() => this.pendingNameInput?.nativeElement?.focus(), 50);
  }

  confirmTicketRow() {
    if (!this.pendingTicket.name?.trim()) return;
    if (!this.tickets) this.tickets = [];
    this.tickets.push({ ...this.pendingTicket });
    this.numTickets++;
    this.addingTicketRow = false;
    this.pendingTicket = { name: '', price: null, only_tpv_sales: false, allow_discounts: true, active: true, levels: [], sessions: [], special_seats: false, seats: [] };
    this.changing = false;
    this.ticketService.setTicketsVenue(this.tickets);
    this.ticketService.setTicketsNum(this.numTickets);
    this.getData();
  }

  priceMissing(ticket: any): boolean {
    return ticket == null || ticket.price === null || ticket.price === undefined || ticket.price === '';
  }

  cancelTicketRow() {
    this.addingTicketRow = false;
    this.pendingTicket = { name: '', price: null, only_tpv_sales: false, allow_discounts: true, active: true, levels: [], sessions: [], special_seats: false, seats: [] };
  }

  saveTicketsInline() {
    if (!this.tickets) return;
    this.changing = false;
    this.ticketService.setTicketsVenue(this.tickets);
  }

  saveDate(event: any) {
    if (event) {
      const date = new Date(this.formatter.format(event));
      date.setHours(0);
      date.setMinutes(0);
      if (this.typeDatepicker == 'start') {
        this.startDate = event;
        this.formConfig.controls['sale_start_date'].setValue(date);
        this.startStringDate = formatDate(date, 'dd/MM/yyyy', 'es');
      }
      if (this.typeDatepicker == 'end') {
        this.endDate = event;
        this.formConfig.controls['sale_end_date'].setValue(date);
        this.endStringDate = formatDate(date, 'dd/MM/yyyy', 'es');
      }
      if (this.typeDatepicker == 'auto') {
        this.publishDate = event;
        this.formConfig.controls['publish_date'].setValue(date);
        this.publishStringDate = formatDate(date, 'dd/MM/yyyy', 'es');
      }
    }
    this.saveConfig();
    this.typeDatepicker = null;
  }

  saveConfig() {
    let hasChanges = false;

    if (this.hourInit && this.minuteInit != null) {
      const dateInit = this.formConfig.value.sale_start_date;
      if (dateInit) {
        dateInit.setHours(this.hourInit);
        dateInit.setMinutes(this.minuteInit);
        this.formConfig.value.sale_start_date = dateInit;
        if (this.selectedSession != null && this.sessions[this.selectedSession]) {
          this.sessions[this.selectedSession].sale_start_date = dateInit;
        }
        hasChanges = true;
      }
    }

    if (this.hourEnd && this.minuteEnd != null) {
      const dateEnd = this.formConfig.value.sale_end_date;
      if (dateEnd) {
        dateEnd.setHours(this.hourEnd);
        dateEnd.setMinutes(this.minuteEnd);
        this.formConfig.value.sale_end_date = dateEnd;
        if (this.selectedSession != null && this.sessions[this.selectedSession]) {
          this.sessions[this.selectedSession].sale_end_date = dateEnd;
        }
        hasChanges = true;
      }
    }

    // Siempre guardar la configuración en el servicio, incluso si solo cambiaron las fechas sin horas
    this.editConfig(this.formConfig.value);
  }

  openDatePicker(type: string) {
    if (this.typeDatepicker) {
      this.typeDatepicker = null;
      return;
    }
    this.typeDatepicker = type;
  }

  changeHourInit(event: any) {
    this.hourInit = event;
    this.saveConfig();
  }

  changeMinuteInit(event: any) {
    this.minuteInit = event;
    this.saveConfig();
  }

  changeHourEnd(event: any) {
    this.hourEnd = event;
    this.saveConfig();
  }

  changeMinuteEnd(event: any) {
    this.minuteEnd = event;
    this.saveConfig();
  }

  editConfig(payload: any) {
    this.ticketService.setTicketsConfig(payload);
  }

  closeTicketsLevel(ticket) {
    this.tickets.forEach(value => {
      if (value.level == ticket.id) {
        value.open = !value.open
      }
    });
  }

  nextStep() {
    let step = { tab: 4, name: '4. Aforo/Mapa de butacas', slug: 'map-event' };
    // let step = { tab: 4, name: 'Descuentos/abonos', slug: 'discount-event' };
    this.changeTab.emit(step);
  }

  changePrice(ticket: any, levelId?: number, index?: number) {
    if (levelId != null && index != null && ticket.ticket_seats && ticket.ticket_seats.length > 0) {
      let seatLevel = ticket.ticket_seats?.find((element: any) => element.seat.id_level == levelId);
      ticket.ticket_seats.forEach((element: any) => {
        if (element.seat.id_level == levelId) {
          element.price = seatLevel.price;
        }
      });
      this.tickets[index] = ticket;
    }
    this.editTickets();
  }

  ngOnDestroy() {
    // this.subscriber.unsubscribe();
    this.infoSubscriber?.unsubscribe();
  }

  changeSession(event: any) {
    this.sessions[this.selectedSession].max_tickets_per_user = this.formConfig.value.max_tickets_per_user;

    this.tickets = [];
    this.selectedSession = event;

    this.formConfig.patchValue(this.sessions[event]);

    this.startStringDate = null;
    this.endStringDate = null;
    this.hourInit = null;
    this.minuteInit = null;
    this.hourEnd = null;
    this.minuteEnd = null;

    if (this.sessions[event].sale_start_date) {
      this.startStringDate = formatDate(this.sessions[event].sale_start_date, 'dd/MM/yyyy', 'es');
      this.hourInit = this.sessions[event].sale_start_date.getHours();
      this.minuteInit = this.sessions[event].sale_start_date.getMinutes();
    }
    if (this.sessions[event]?.sale_end_date) {
      this.endStringDate = formatDate(this.sessions[event].sale_end_date, 'dd/MM/yyyy', 'es');
      this.hourEnd = this.sessions[event].sale_end_date.getHours();
      this.minuteEnd = this.sessions[event].sale_end_date.getMinutes();
    }
  }

  changeTypeTicketsSession(event: any) {
    if (event) {
      this.selectedSession = null;
      // Initialize tickets for each session
      this.sessions.forEach((session, index) => {
        if (!this.ticketsBySession[index]) {
          this.ticketsBySession[index] = [];
        }
        // Expand first session by default
        if (index === 0) {
          this.expandedSessions[index] = true;
        }
      });
      // Build hierarchical data for dropdown
      this.buildHierarchicalData();
    }
    else {
      this.selectedSession = 0;
    }
  }

  toggleSession(index: number) {
    this.expandedSessions[index] = !this.expandedSessions[index];
  }

  isSessionExpanded(index: number): boolean {
    return this.expandedSessions[index] || false;
  }

  getSessionTickets(sessionIndex: number): any[] {
    if (!this.ticketsBySession[sessionIndex]) {
      this.ticketsBySession[sessionIndex] = [];
    }
    return this.ticketsBySession[sessionIndex];
  }

  editTicketFromSession(sessionIndex: number, ticket: any, ticketIndex: number) {
    // Cargar la sesión en la que está esta entrada
    const session = this.sessions[sessionIndex];
    const ticketToEdit = { ...ticket, sessions: [session] };

    const dialogRef = this.dialog.open(NewTicketComponent, {
      panelClass: ['info-dialog', 'not-padding'],
      data: { ticket: ticketToEdit, venue: this.venue, levels: this.levels, sessions: this.sessions, eventName: this.createService.getInfoEvent()?.values?.title }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.sessions && result.sessions.length > 0) {
        // Eliminar el ticket de su sesión actual
        this.ticketsBySession[sessionIndex].splice(ticketIndex, 1);

        // Agregar el ticket actualizado a las sesiones seleccionadas
        result.sessions.forEach((sess: any) => {
          const newSessionIndex = this.sessions.findIndex(s => s.start_date === sess.start_date);
          if (newSessionIndex !== -1) {
            if (!this.ticketsBySession[newSessionIndex]) {
              this.ticketsBySession[newSessionIndex] = [];
            }

            const ticketCopy = { ...result, id_session: sess.id };
            this.ticketsBySession[newSessionIndex].push(ticketCopy);
            this.ticketsBySession[newSessionIndex].sort((a: any, b: any) => this.getTicketMinOrderBuy(a) - this.getTicketMinOrderBuy(b));
          }
        });

        this.saveTicketsToService();
      }
    });
  }

  deleteTicketFromSession(sessionIndex: number, ticketIndex: number) {
    this.ticketsBySession[sessionIndex].splice(ticketIndex, 1);
    this.saveTicketsToService();
  }

  changeTicketPriceInSession(sessionIndex: number) {
    this.saveTicketsToService();
  }

  applyPricesToAllSessions(sourceSessionIndex: number) {
    const sourceTickets = this.ticketsBySession[sourceSessionIndex];

    if (!sourceTickets || sourceTickets.length === 0) {
      return;
    }

    // Copy tickets to all other sessions
    this.sessions.forEach((session, index) => {
      if (index !== sourceSessionIndex) {
        // Deep copy the tickets
        this.ticketsBySession[index] = JSON.parse(JSON.stringify(sourceTickets));
      }
    });

    this.saveTicketsToService();
  }

  saveTicketsToService() {
    // Save tickets by session to the service
    const config = this.ticketService.getTicketsConfig() || {};
    config.ticketsBySession = this.ticketsBySession;
    config.typeTicketsSession = this.typeTicketsSession;
    this.ticketService.setTicketsConfig(config);
  }

  getSessionDateString(session: any): string {
    if (!session.start_date) {
      return 'Sesión sin fecha';
    }
    const date = new Date(session.start_date);
    const dateStr = formatDate(date, 'dd/MM/yyyy - HH:mm', 'es') + 'h';

    // Get event name from CreateEventService or use a default
    const saved = this.createService.getInfoEvent();
    const eventName = saved?.values?.name || this.event?.name || 'Evento';

    return `${eventName} - ${dateStr}`;
  }

  buildHierarchicalData() {
    if (!this.sessions || this.sessions.length === 0) {
      this.hierarchicalData = { years: [] };
      return;
    }

    const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    const yearMap: { [year: string]: { [monthYear: string]: { session: any; index: number }[] } } = {};

    this.sessions.forEach((session, index) => {
      const date = new Date(session.start_date);
      const year = date.getFullYear().toString();
      const monthName = months[date.getMonth()];
      const monthYear = `${monthName} ${year}`;

      if (!yearMap[year]) {
        yearMap[year] = {};
      }
      if (!yearMap[year][monthYear]) {
        yearMap[year][monthYear] = [];
      }

      yearMap[year][monthYear].push({ session, index });
    });

    this.hierarchicalData.years = Object.keys(yearMap)
      .sort()
      .map(year => ({
        year,
        months: Object.keys(yearMap[year]).map(monthYear => ({
          monthYear,
          monthName: monthYear,
          sessions: yearMap[year][monthYear]
        }))
      }));
  }

  toggleYear(year: string, event: Event) {
    event.stopPropagation();
    this.yearExpanded[year] = !this.yearExpanded[year];
  }

  toggleMonth(monthYear: string, event: Event) {
    event.stopPropagation();
    this.monthExpanded[monthYear] = !this.monthExpanded[monthYear];
  }

  toggleAllSessions(event: any) {
    event.stopPropagation();
    this.allSelected = !this.allSelected;

    if (this.allSelected) {
      this.selectedSessionIndices = this.sessions.map((_, index) => index);
      this.sessions.forEach((_, index) => {
        this.expandedSessions[index] = true;
      });
    } else {
      this.selectedSessionIndices = [];
    }
  }

  toggleYearSelection(year: string, event: any) {
    event.stopPropagation();

    const yearData = this.hierarchicalData.years.find(y => y.year === year);
    if (!yearData) return;

    const yearSessionIndices: number[] = [];
    yearData.months.forEach(month => {
      month.sessions.forEach(s => yearSessionIndices.push(s.index));
    });

    const allYearSelected = yearSessionIndices.every(idx => this.selectedSessionIndices.includes(idx));

    if (allYearSelected) {
      this.selectedSessionIndices = this.selectedSessionIndices.filter(idx => !yearSessionIndices.includes(idx));
    } else {
      yearSessionIndices.forEach(idx => {
        if (!this.selectedSessionIndices.includes(idx)) {
          this.selectedSessionIndices.push(idx);
          this.expandedSessions[idx] = true;
        }
      });
    }
  }

  toggleMonthSelection(monthYear: string, event: any) {
    event.stopPropagation();

    let monthSessionIndices: number[] = [];
    this.hierarchicalData.years.forEach(year => {
      const month = year.months.find(m => m.monthYear === monthYear);
      if (month) {
        monthSessionIndices = month.sessions.map(s => s.index);
      }
    });

    const allMonthSelected = monthSessionIndices.every(idx => this.selectedSessionIndices.includes(idx));

    if (allMonthSelected) {
      this.selectedSessionIndices = this.selectedSessionIndices.filter(idx => !monthSessionIndices.includes(idx));
    } else {
      monthSessionIndices.forEach(idx => {
        if (!this.selectedSessionIndices.includes(idx)) {
          this.selectedSessionIndices.push(idx);
          this.expandedSessions[idx] = true;
        }
      });
    }
  }

  toggleSessionSelection(sessionIndex: number, event: any) {
    event.stopPropagation();

    const idx = this.selectedSessionIndices.indexOf(sessionIndex);
    if (idx > -1) {
      this.selectedSessionIndices.splice(idx, 1);
    } else {
      this.selectedSessionIndices.push(sessionIndex);
      this.expandedSessions[sessionIndex] = true;
    }
  }

  isYearSelected(year: string): boolean {
    const yearData = this.hierarchicalData.years.find(y => y.year === year);
    if (!yearData) return false;

    const yearSessionIndices: number[] = [];
    yearData.months.forEach(month => {
      month.sessions.forEach(s => yearSessionIndices.push(s.index));
    });

    return yearSessionIndices.length > 0 && yearSessionIndices.every(idx => this.selectedSessionIndices.includes(idx));
  }

  isMonthSelected(monthYear: string): boolean {
    let monthSessionIndices: number[] = [];
    this.hierarchicalData.years.forEach(year => {
      const month = year.months.find(m => m.monthYear === monthYear);
      if (month) {
        monthSessionIndices = month.sessions.map(s => s.index);
      }
    });

    return monthSessionIndices.length > 0 && monthSessionIndices.every(idx => this.selectedSessionIndices.includes(idx));
  }

  isSessionSelected(sessionIndex: number): boolean {
    return this.selectedSessionIndices.includes(sessionIndex);
  }

  preventNegative(event: KeyboardEvent) {
    if (['-', '+', 'e', 'E'].includes(event.key)) {
      event.preventDefault();
    }
  }

  formatPrice(ticket: any) {
    if (ticket.price !== null && ticket.price !== undefined && ticket.price !== '') {
      // Red de seguridad ante valores negativos pegados (el keydown solo bloquea el tecleo).
      ticket.price = Number(ticket.price) < 0 ? '0.00' : Number(ticket.price).toFixed(2);
    }
  }

  formatLevelPrice(ticket: any, levelId: number) {
    let levelInfo = this.getTicketLevel(ticket, levelId);
    if (levelInfo && levelInfo.price !== null && levelInfo.price !== undefined && levelInfo.price !== '') {
      levelInfo.price = Number(levelInfo.price) < 0 ? '0.00' : Number(levelInfo.price).toFixed(2);
    }
  }
}
